import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignRunningItem from "../user-campaigns-running-item/component";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import HeaderMobileMenu from "../header-mobile-menu/component";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {demoRegister} from "../../services/demoRegister";
import ModalLang from "../modal-lang/component";
import ModalAutorenew from "../modal-autorenew/component";
import Moment from 'react-moment';
import ModalStopCampaign from "../modal_stopcampaign/component";
import LanguageButton from "../language-button/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class userCampaignsRunningEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            renewLoader: false,
            renewModal: false,
            stopModal: false,
            advertising_name: null,
            budget: null,
            currency: null,
            email: null,
            id: null,
            industry: null,
            landingpage: null,
            landingepage_address: null,
            landingpage_advertiser: null,
            landingpage_email: null,
            landingpage_phone: null,
            landingpage_url: null,
            language: null,
            website: null,
            phone: null,
            regions: null,
            invoice_hash: null,
            related_industries: null,
            target_slogan: null,
            renew: null,
            today: new Date(),
            user_email: null,
            facebook_demographics: null,
            keyword_languages: {},
            tab: "campaign"
        };
        this._autoRenew = this._autoRenew.bind(this);
        this._stopCampaign = this._stopCampaign.bind(this);
        this._terminate = this._terminate.bind(this);
    }

    componentDidMount() {
        try {
            this.setState({hash: this.props.match.params.hash}, () => {
                this._updateCampaign();
            });
        } catch (e) {}
    }

    _updateCampaign() {
        dataRegister.singleCampaign(salesChannelRegister.get("market"), langRegister.lang(), this.state.hash).then((response) => {
            if (!response.errors) {
                this._setValues(response);
            }
        }, (error) => {});
    }

    _setValues(data) {
        this.state.advertising_name = data.advertising_name ? data.advertising_name : "";
        this.state.budget = data.budget_per_channel ? data.budget_per_channel : {};
        this.state.currency = data.currency ? data.currency : "";
        this.state.email = data.email ? data.email : "";
        this.state.id = data.id ? data.id : "";
        this.state.industry = data.industry ? data.industry : "";
        this.state.website = data.website ? data.website : null;
        this.state.optimization = data.optimization ? +data.optimization : "";
        this.state.landingpage = data.landingpage ? data.landingpage : null;
        this.state.landingepage_address = data.landingepage_address ? data.landingepage_address : "";
        this.state.landingpage_advertiser = data.landingpage_advertiser ? data.landingpage_advertiser : "";
        this.state.landingpage_email = data.landingpage_email ? data.landingpage_email : "";
        this.state.landingpage_phone = data.landingpage_phone ? data.landingpage_phone : "";
        this.state.landingpage_url = data.landingpage_url ? data.landingpage_url : "";
        this.state.language = data.language ? data.language : "";
        this.state.phone = data.phone ? data.phone : "";
        this.state.regions = data.regions ? data.regions : {};
        this.state.related_industries = data.related_industries ? data.related_industries : [];
        this.state.facebook_demographics = data.facebook_demographics ? data.facebook_demographics : null;
        this.state.target_slogan = data.target_slogan ? data.target_slogan : null;
        this.state.duration = data.duration ? data.duration : "";
        this.state.start_date = data.start_date ? data.start_date : "";
        this.state.renew = data.renew;
        this.state.lockin = data.lock_in;
        this.state.remaining_lock_in = data.remaining_lock_in;
        this.state.invoice_hash = data.invoice_hash;
        this.state.keyword_languages = data.keyword_languages ? data.keyword_languages : {};
        this.setState({
            advertising_name: this.state.advertising_name,
            budget: this.state.budget,
            currency: this.state.currency,
            email: this.state.email,
            id: this.state.id,
            industry: this.state.industry,
            website: this.state.website,
            landingpage: this.state.landingpage,
            landingepage_address: this.state.landingepage_address,
            landingpage_advertiser: this.state.landingpage_advertiser,
            landingpage_email: this.state.landingpage_email,
            landingpage_phone: this.state.landingpage_phone,
            landingpage_url: this.state.landingpage_url,
            language: this.state.language,
            phone: this.state.phone,
            regions: this.state.regions,
            related_industries: this.state.related_industries,
            facebook_demographics: this.state.facebook_demographics,
            target_slogan: this.state.target_slogan,
            renew: this.state.renew !== 0,
            lockin: this.state.lockin?this.state.lockin:0,
            remaining_lock_in: this.state.remaining_lock_in,
            start_date: this.state.start_date,
            isLoading: false,
            invoice_hash: this.state.invoice_hash,
            keyword_languages: this.state.keyword_languages
        }, () => {
            console.log(this.state.lockin);

            if(!this.state.facebook_demographics && (this.renderKeywordLanguages().length > 1 || this.state.target_slogan)){
                this.state.facebook_demographics = {};
                this.state.facebook_demographics.target_slogan = this.state.target_slogan;
                this.state.facebook_demographics.keywords = this.renderKeywordLanguages();
                this.setState({facebook_demographics: this.state.facebook_demographics});
            }else if(this.state.facebook_demographics){
                this.state.facebook_demographics.target_slogan = this.state.target_slogan;
                this.state.facebook_demographics.keywords = this.renderKeywordLanguages();
                this.setState({facebook_demographics: this.state.facebook_demographics});
            }

        });
    }

    _back() {
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/campaigns/running");
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/login");
    }

    _goLanding() {
        if (this.state.landingpage) {
            try {
                window.open("https://" + this.state.landingpage_url + "." + dataRegister.domain, '_blank');
            } catch (error) {
            }
        } else if (this.state.website) {
            try {
                window.open(this.state.website, '_blank');
            } catch (error) {}
        }
    }

    _autoRenew(value) {
        if (value) {
            this.setState({renewLoader: true, renewModal: false});
            dataRegister.renew(salesChannelRegister.get("market"), this.props.match.params.hash, {auto_renew: !this.state.renew}).then((response) => {
                if (!response.errors) {
                    this.setState({renewLoader: false, renew: !this.state.renew});
                } else {
                    this.setState({renewLoader: false});
                }
            }, (error) => {
                this.setState({renewLoader: false});
            });
        } else {
            this.setState({renewModal: false});
        }
    }

    _setRenew() {
        if (this.state.renew) {
            this.setState({renewModal: true});
        } else {
            this._autoRenew(true);
        }
    }

    _stopCampaign(){
        this.setState({stopModal: false});
    }

    _terminate(){
        if(this.props.match.params.hash){
            this.setState({isLoading: true, stopModal: false}, () => {
                dataRegister.terminateCampaign(salesChannelRegister.get('market'), this.props.match.params.hash).then((response) => {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/user/campaigns/history/" + this.props.match.params.hash);
                }, (error) => {
                    this.setState({isLoading: false})
                });
            });
        }
    }

    _selectInvoice() {
        window.open("https://invoice." + dataRegister.domain + "/" + salesChannelRegister.get("market") + "/" + this.state.invoice_hash, '_blank');
    }

    _selectSummary(){
        window.open("https://confirmation." + dataRegister.domain + "/" + salesChannelRegister.get("market") + "/" + this.props.match.params.hash, '_blank');
    }

    _renderSex(value) {
        if (value === "m") {
            return langRegister.lang() === "sv" ? "Män" : "Male"
        } else if (value === "f") {
            return langRegister.lang() === "sv" ? "Kvinnor" : "Female"
        }
    }

    _renderLang(lang) {
        if (lang === "sv") {
            return langRegister.lang() === "sv" ? "Svenska" : "Swedish"
        } else if (lang === "en") {
            return langRegister.lang() === "sv" ? "Engelska" : "English"
        }
    }

    _renderChannel(channel) {
        let item = channel;
        if (item === "fb") {
            item = "facebook"
        }
        if(item === "facebook"){
            return "Facebook social"
        }else if(item === "instagram"){
            return "Instagram social"
        }else if(item === "google"){
            return "Google search"
        }else if(item === "bing"){
            return "Bing search"
        }
    }

    renderKeywordLanguages(){
        let list = [];
        try {
            if(this.state.keyword_languages.google && this.state.keyword_languages.bing){
                list = this.state.keyword_languages.google.concat(this.state.keyword_languages.bing);
                const final = [];
                list.map((e,i)=> !final.includes(e) && final.push(e) );
                list = final;
            }else if(this.state.keyword_languages.google && !this.state.keyword_languages.bing){
                list = this.state.keyword_languages.google;
            }else if(!this.state.keyword_languages.google && this.state.keyword_languages.bing){
                list = this.state.keyword_languages.bing;
            }
            return list;
        }catch (e) {
            return list;
        }
    }

    renderKeywordLanguageTitle(item){
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska'},
            'ar': {'en': 'Arabic', 'sv': 'Arabiska'},
            'fi': {'en': 'Finnish', 'sv': 'Finska'},
            'de': {'en': 'German', 'sv': 'Tyska'},
            'zh': {'en': 'Chinese', 'sv': 'Kinesiska'},
            'tr': {'en': 'Turkish', 'sv': 'Turkiska'},
            'es': {'en': 'Spanish', 'sv': 'Spanska'},
            'el': {'en': 'Greek', 'sv': 'Grekiska'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska'},
            'cs': {'en': 'Czech', 'sv': 'Tjeckiska'},
            'da': {'en': 'Danish', 'sv': 'Danska'},
            'mt': {'en': 'Maltese', 'sv': 'Maltesisk'},
            'hr': {'en': 'Croatian', 'sv': 'Kroatisk'},
            'pa': {'en': 'Punjabi', 'sv': 'Punjabi'},
            'fr': {'en': 'French', 'sv': 'Franska'},
            'nl': {'en': 'Dutch', 'sv': 'Holländska'},
            'ko': {'en': 'Korean', 'sv': 'Koreanska'},
            'hi': {'en': 'Hindi', 'sv': 'Hindi'},
            'pt': {'en': 'Portuguese', 'sv': 'Portugisiska'},
            'ur': {'en': 'Urdu', 'sv': 'Urdu'},
            'it': {'en': 'Italian', 'sv': 'Italienska'},
            'ru': {'en': 'Russian', 'sv': 'Ryska'},
            'pl': {'en': 'Polish', 'sv': 'Polska'},
            'ja': {'en': 'Japanese', 'sv': 'Japanska'},
            'sr': {'en': 'Serbian', 'sv': 'Serb'},
            'ms': {'en': 'Malay', 'sv': 'Malay'}
        };
        try {
            return items[item][langRegister.lang()];
        }catch (e) {
            return item;
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderName(item){
        try {
            if(salesChannelRegister.get('default_language') !== langRegister.lang() && item.internationalname){
                return item.internationalname;
            }else{
                return item.name
            }
        }catch (e) {
            return item.name
        }
    }

    _renderText(item) {
        return langRegister.get("user-campaigns-running-edit", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.renewModal &&
                    <ModalAutorenew landingpage={this.state.landingpage} setAutorenew={this._autoRenew} props={this.props}/>
                }
                {
                    this.state.stopModal &&
                    <ModalStopCampaign stop={this._stopCampaign} terminate={this._terminate}/>
                }
                <div className={Styles.view}>
                    {
                        !this.state.isLoading &&
                        <div className={Styles.contentHeader}>
                            <div className={Styles.contentHeaderTitle}>
                                <div className={Styles.contentHeaderTitleInner}>
                                    {this._renderText("item_2")}{" "}<span className={Styles.contentHeaderTitleBold}>#{this.state.id}</span>{" "}
                                    {
                                        this.state.start_date &&
                                        <span>{this._renderText("item_48")}{" "}
                                            <span className={Styles.contentHeaderTitleBold}>
                                        <Moment diff={this.state.today} unit="days" add={{days: this.state.duration}}>{this.state.start_date}</Moment>
                                    </span>
                                            {" "}{this._renderText("item_50")}
                                </span>
                                    }
                                    {
                                        !this.state.start_date &&
                                        this._renderText("item_49")
                                    }
                                </div>
                            </div>
                            <LanguageButton props={this.props}/>
                            <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                                {this._renderText("item_1")}
                            </div>
                        </div>
                    }
                    <div className={Styles.container}>

                        {
                            this.state.isLoading &&
                            <div className={Styles.loader}>
                                <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                            </div>
                        }
                        {
                            !this.state.isLoading &&
                            <div className={cx(Styles.tabsContainer)}>
                                <div onClick={() => this.setState({tab: "campaign"})} className={
                                    cx(Styles.tabsContainerItem,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.tab === "campaign",
                                        })
                                }>
                                    {this._renderText("item_63")}
                                </div>
                                <div onClick={() => this.setState({tab: "landingpage"})} className={
                                    cx(Styles.tabsContainerItem,
                                        {
                                            [Styles.tabsContainerItemActive]: this.state.tab === "landingpage",
                                        })
                                }>
                                    {this._renderText("item_64")}
                                </div>
                            </div>
                        }
                        {
                            !this.state.isLoading &&
                            <div className={Styles.summaryContainer}>

                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_8")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_9")}{" "}
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.industry}{" "}</span>
                                        }
                                </span>
                                            {this._renderText("item_10")}{" "}
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                            {this.state.duration}{" "}
                            </span>
                                            {this._renderText("item_11")}
                                            {' '}
                                            {this._renderText("item_66")}
                                            {' '}
                                            {
                                                this.state.optimization === 2 &&
                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {this._renderText("item_67")}
                                                    </span>
                                            }
                                            {
                                                this.state.optimization === 1 &&
                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {this._renderText("item_68")}
                                                    </span>
                                            }
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_12")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_13")}{" "}
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.advertising_name}{" "}</span>
                                        }
                                </span>
                                            {this._renderText("item_14")}
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.tab === "campaign" && this.state.phone !== "" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_15")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_16")}{" "}
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.phone}{" "}</span>
                                        }
                                </span>
                                            {this._renderText("item_17")}
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_18")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <span>{this._renderText("item_19")}{" "}</span>
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            Object.keys(this.state.budget).map((key, i) => {
                                                return (
                                                    <span>
                                                          <span
                                                              className={Styles.summaryContainerItemSummaryChannel}>{this._renderChannel(key)}</span>
                                                        {
                                                            i !== Object.keys(this.state.budget).length - 1 &&
                                                            <span>, </span>
                                                        }
                                                    </span>
                                                )
                                            })
                                        }
                                    </span>
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_20")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <span>{this._renderText("item_21")}{" "}</span>
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                {this._renderLang(this.state.language)}
                            </span>
                                            {
                                                this.state.related_industries.length > 0 &&
                                                <span>.&nbsp;{this._renderText("item_22")}{" "}</span>
                                            }
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.related_industries.map((prop, key) => {
                                                if (key === this.state.related_industries.length - 1) {
                                                    return (
                                                        <span>{prop.name[langRegister.lang()]}</span>
                                                    )
                                                } else {
                                                    return (
                                                        <span>{prop.name[langRegister.lang()]}, </span>
                                                    )
                                                }
                                            })
                                        }
                                </span>
                                            <span>{this._renderText("item_23")}{" "}</span>
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            Object.keys(this.state.regions).map((prop, key) => {
                                                if (key === Object.keys(this.state.regions).length - 1) {
                                                    return (
                                                        <span>{this._renderName(this.state.regions[prop])}</span>
                                                    )
                                                } else {
                                                    return (
                                                        <span>{this._renderName(this.state.regions[prop])}, </span>
                                                    )
                                                }
                                            })
                                        }
                                </span>
                                        </div>
                                    </div>
                                }


                                {
                                    this.state.facebook_demographics && this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_24")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {
                                                (this.state.facebook_demographics.gender || (this.state.facebook_demographics.age_min && this.state.facebook_demographics.age_max))  &&
                                                <span>{this._renderText("item_25")}{" "}</span>
                                            }
                                            {
                                                !this.state.facebook_demographics.gender && (this.state.facebook_demographics.age_min && this.state.facebook_demographics.age_max) &&
                                                <span className={Styles.summaryContainerItemSummaryBold}>{this._renderSex("m")}, {this._renderSex("f")}{" "}</span>
                                            }
                                            {
                                                this.state.facebook_demographics.gender &&
                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                    {this._renderSex(this.state.facebook_demographics.gender)}
                                                    {
                                                        !this.state.facebook_demographics.age_min && !this.state.facebook_demographics.age_max &&
                                                        <span>.</span>
                                                    }
                                                    {" "}
                                                </span>
                                            }
                                            {
                                                this.state.facebook_demographics.age_min && this.state.facebook_demographics.age_max &&
                                                <span>{this._renderText("item_26")}{" "}<span className={Styles.summaryContainerItemSummaryBold}>{this.state.facebook_demographics.age_min} - {this.state.facebook_demographics.age_max}</span>.&nbsp;</span>
                                            }
                                            {
                                                this.state.facebook_demographics.interests &&
                                                <span>{this._renderText("item_61")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {
                                                            this.state.facebook_demographics.interests.map((prop, key) => {
                                                                if (key === this.state.facebook_demographics.interests.length - 1) {
                                                                    return (
                                                                        <span>{prop.name}</span>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <span>{prop.name}, </span>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </span>
                                                    .{" "}
                                                </span>
                                            }
                                            {
                                                this.state.facebook_demographics.behaviors &&
                                                <span>{this._renderText("item_65")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {
                                                            this.state.facebook_demographics.behaviors.map((prop, key) => {
                                                                if (key === this.state.facebook_demographics.behaviors.length - 1) {
                                                                    return (
                                                                        <span>{prop.name}</span>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <span>{prop.name}, </span>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </span>
                                                    .{" "}
                                                </span>
                                            }
                                            {
                                                this.state.target_slogan &&
                                                <span>{this._renderText("item_62")}&nbsp;<span className={Styles.summaryContainerItemSummaryBold}>{this.state.target_slogan.trim()}.</span></span>
                                            }
                                            {
                                                this.renderKeywordLanguages().length > 1 &&
                                                <span>{this._renderText("item_69")}&nbsp;<span className={Styles.summaryContainerItemSummaryBold}>{
                                                    this.renderKeywordLanguages().map((prop, key) => {
                                                        if (key === this.renderKeywordLanguages().length - 1) {
                                                            return (
                                                                <span>{this.renderKeywordLanguageTitle(prop)}</span>
                                                            )
                                                        } else {
                                                            return (
                                                                <span>{this.renderKeywordLanguageTitle(prop)},{" "}</span>
                                                            )
                                                        }
                                                    })
                                                }</span></span>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_27")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_28")}{" "}
                                            {
                                                Object.keys(this.state.budget).map((key, i) => {

                                                    return (
                                                        <span>
                                                        <span
                                                            className={Styles.summaryContainerItemSummaryBold}>{this._renderNumbers(Math.round(this.state.budget[key]))}{" "}{this.state.currency}</span>
                                                            {" "}{this._renderText("item_29")}
                                                            <span
                                                                className={Styles.summaryContainerItemSummaryChannel}>{" "}{this._renderChannel(key)}</span>
                                                            {
                                                                i !== Object.keys(this.state.budget).length - 1 &&
                                                                <span>,{" "}</span>
                                                            }
                                                    </span>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.landingpage && this.state.tab === "landingpage" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_30")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <div onClick={() => this._goLanding()}
                                                 className={Styles.summaryContainerItemLink}>
                                                https://www.{this.state.landingpage_url}.{dataRegister.domain}
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.website && this.state.tab === "landingpage" &&
                                    <div className={
                                        cx(Styles.summaryContainerItem,
                                            {
                                                [Styles.tabsContainerItemNoBorder]: !this.state.landingpage
                                            })
                                    }>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_30")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <div onClick={() => this._goLanding()}
                                                 className={Styles.summaryContainerItemLink}>
                                                {this.state.website}
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.landingpage && this.state.tab === "landingpage" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_31")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_32")}{" "}
                                            <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            <span>{this.state.landingpage_phone}{" "}</span>
                                        }
                                </span>
                                            {this._renderText("item_33")}
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.landingpage && this.state.tab === "landingpage" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_34")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_35")}{" "}<span
                                            className={Styles.summaryContainerItemSummaryBold}>{this.state.landingepage_address}</span>{" "}{this._renderText("item_36")}
                                        </div>
                                    </div>

                                }
                                {
                                    this.state.landingpage && this.state.tab === "landingpage" &&
                                    <div className={
                                        cx(Styles.summaryContainerItem,
                                            {
                                                [Styles.tabsContainerItemNoBorder]: this.state.landingpage
                                            })
                                    }>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_37")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            {this._renderText("item_38")}{" "}<span
                                            className={Styles.summaryContainerItemSummaryBold}>{this.state.landingpage_email}</span>{" "}{this._renderText("item_39")}
                                        </div>
                                    </div>

                                }
                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_51")}
                                        </div>
                                        {
                                            this.state.lockin > 1 && this.state.remaining_lock_in > 1 &&
                                            <div className={Styles.summaryContainerItemSummary}>
                                                {this._renderText("item_52")}{" "}<span
                                                className={Styles.summaryContainerItemSummaryBold}>{this._renderText("item_53")}</span>.{" "}{this._renderText("item_55")}{" "}
                                                <span className={Styles.summaryContainerItemSummaryBold}>{this.state.remaining_lock_in - 1}</span>{" "}
                                                {
                                                    (this.state.remaining_lock_in - 1) > 1 &&
                                                    <span>{this._renderText("item_56")}</span>
                                                }
                                                {
                                                    (this.state.remaining_lock_in - 1) < 2 &&
                                                    <span>{this._renderText("item_57")}</span>
                                                }
                                                {" "}{this._renderText("item_58")}
                                            </div>
                                        }
                                        {
                                            (this.state.lockin < 2 || this.state.remaining_lock_in === 1) &&
                                            <div className={Styles.summaryContainerItemSummary}>
                                                {this._renderText("item_52")}{" "}<span
                                                className={Styles.summaryContainerItemSummaryBold}>{this._renderText("item_54")}</span>
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_59")}
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <span>{this._renderText("item_60")}{" "}</span>
                                            <span className={Styles.summaryContainerItemSummaryBold}>{this.state.email}</span>
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.lockin < 2 || (this.state.remaining_lock_in === 1)) && this.state.tab === "campaign" &&
                                    <div className={Styles.summaryContainerItem}>
                                        <div className={Styles.summaryContainerItemTitle}>
                                            {this._renderText("item_40")}
                                        </div>
                                        <div className={cx(Styles.summaryContainerItemAutoRenew)}>
                                            {
                                                !this.state.renewLoader &&
                                                <div className={Styles.summaryContainerItemSummaryBold}>
                                                    {this._renderText("item_41")}
                                                </div>
                                            }
                                            {
                                                (this.state.renew && !this.state.renewLoader) &&
                                                <img onClick={() => this._setRenew()}
                                                     className={Styles.summaryContainerItemAutoRenewIcon}
                                                     src={require("../../assets/images/push_black_on.svg")}/>
                                            }
                                            {
                                                !this.state.renew && !this.state.renewLoader &&
                                                <img onClick={() => this._setRenew()}
                                                     className={Styles.summaryContainerItemAutoRenewIcon}
                                                     src={require("../../assets/images/push_black_off.svg")}/>
                                            }
                                            {
                                                this.state.renewLoader &&
                                                <BeatLoader size={15} color={'#000000'} loading={true}/>
                                            }
                                            {
                                                !this.state.renewLoader &&
                                                <div className={Styles.summaryContainerItemSummaryBold}>
                                                    {this._renderText("item_42")}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.tab === "campaign" &&
                                    <div>
                                        <div className={Styles.dividerTop}/>
                                        <div onClick={() => this._selectInvoice()} className={Styles.buttonBlack}>
                                            {this._renderText("item_43")}
                                        </div>
                                        <div onClick={() => this._selectSummary()} className={cx(Styles.buttonBlack, Styles.buttonBlackBottom)}>
                                            {this._renderText("item_47")}
                                        </div>
                                        <div className={Styles.divider}/>
                                        <div onClick={() => this.setState({stopModal: true})} className={Styles.buttonRed}>
                                            {this._renderText("item_44")}
                                        </div>
                                        <div onClick={() => {
                                            this._back();
                                        }} className={Styles.backButton}>
                                            {this._renderText("item_45")}
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                    </div>
                </div>
            </div>
        )
    }
}

export default userCampaignsRunningEdit


// WEBPACK FOOTER //
// ./src/components/user-campaigns-running-edit/component.js